$(".toolbar__btn").on("click", function () {
  $(".toolbar__options").css("display", "flex").hide().fadeIn(300);
});
$(".toolbar__close").on("click", function () {
  $(".toolbar__options").fadeOut(300);
});
